import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  Avatar,
  Box,
  Checkbox,
  FormHelperText,
  Grid,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { GetCity, GetState } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import ConfirmationDialog from "../../../components/Dialog/confirmationDialog/confrmDialog.js";
import Label from "../../../components/Label";
import RomanianPhoneInput from "../../../components/romaniaPhoneInput/index.js";
import TextInput from "../../../components/TextInputs";
import UploadImageAvatar from "../../../components/UploadImage";
import globalStyle from "../../../globalStyle";
import { setWorkerDetail } from "../../../lib/CompanySlice/WorkerDetailSlice";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { baseUrl } from "../../../services";
import {
  getAddressDetailByPlaceId,
  getSubscriptionDetailById,
} from "../../../services/common/CommonApiFn";
import { companyCanCreateWorker } from "../../../services/company/authenticationApiFn.js";
import { getCompanySelectedServices } from "../../../services/company/serviceCategoryApiFn";
import {
  getWorkerDetail,
  registerWorkerByCompany,
  updateWorkderDetail,
} from "../../../services/worker/authenticationApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";
import { registerWorkerValidation } from "../../../utils/Validation";
// const stripePromise = loadStripe(STRIPE_KEY);

const EXPERTISE = ["Junior", "Intermediate", "Expert"];
const GENDER = ["Male", "Female", "Other"];

const MAIN_SERVICES = 1;
const SUB_SERVICES = 2;

const AddEditWorker = () => {
  const dispatch = useDispatch();
  const openConfirmationDialog = useRef(null);
  const openSubscriptionDialog = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [allServices, setAllServices] = useState([]);
  const [location, setLocation] = useState(null);
  const [subscriptionDetail, setSubscriptionDetail] = useState(null);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const uploadRef = useRef();
  const [inputValues, setInputValues] = useState({
    image: null,
    name: "",
    email: "",
    contact: "",
    country: "Romania",
    city: "",
    state: "",
    location: "",
    gender: "",
    expertise: "",
    password: "",
    confirmPassword: "",
    workerBgImages: [],
  });

  const [inputError, setInputError] = useState({
    image: false,
    name: false,
    email: false,
    isEmailValid: false,
    contact: false,
    location: false,
    country: false,
    city: false,
    state: false,
    expertise: false,
    gender: false,
    password: false,
    isPasswordStrong: false,
    confirmPassword: false,
    workerBgImages: false,
    isPasswordMatch: false,
  });

  const { currentLanguage } = useSelector((state) => state.translationReducer);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const userData = useSelector((state) => state.userData.user);
  const workerDetail = useSelector(
    (state) => state.workerDetailReducer.workerDetail
  );

  const fetchWorkerDetail = async () => {
    try {
      const response = await getWorkerDetail(workerDetail._id, "company");
      if (response?.data?.status === "success") {
        setInputValues((val) => ({
          ...val,
          image: response.data.data.profileImg,
          name: response.data.data.name,
          email: response.data.data.email,
          contact: response.data.data.contact,
          location: response.data.data.location,
          expertise: response.data.data.expertise,
          gender: response.data.data.gender,
          workerBgImages: response.data.data.backgroundImages,
          country: response.data.data.country,
          city: response.data.data.city,
          state: response.data.data.state,
        }));
        setLocation(response.data.data?.location);
        fetchAllServiceWithSubServices(response.data.data.services);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  const fetchAllServiceWithSubServices = async (workerService) => {
    try {
      setIsLoading(true);

      const response = await getCompanySelectedServices(userData?.adminId);
      if (response?.data?.status === "success") {
        const allServicesData = response?.data?.data;

        const selectedServices = workerService || [];

        const tempArray = allServicesData.map((service) => {
          const selectedService = selectedServices.find(
            (selected) => selected.services === service._id
          );

          return {
            ...service,
            isSelected: !!selectedService,
            subservices: service.subservices.map((sub) => ({
              ...sub,

              isSelected: selectedService
                ? selectedService.subServices.includes(sub.serviceSubCategoryId)
                : false,
            })),
          };
        });

        setAllServices(tempArray);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubscriptionDetail = async () => {
    try {
      const response = await getSubscriptionDetailById(
        userData?.subscriptionId
      );
      if (response?.data?.status === "success") {
        const data = response?.data?.data;
        const staff = data?.features?.find(
          (feature) => feature?.type === "staff"
        );
        const services = data?.features?.find(
          (feature) => feature?.type === "service"
        );
        setSubscriptionDetail({
          ...data,
          staffLimit: staff?.specifics?.staffLimit || 0,
          maxServicesLimit: services?.specifics?.maxServices || MAIN_SERVICES,
          maxSubServicesLimit:
            services?.specifics?.maxSubServices || SUB_SERVICES,
        });
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    }
  };

  useEffect(() => {
    if (workerDetail) {
      fetchWorkerDetail();
    } else {
      fetchAllServiceWithSubServices();
    }
  }, [workerDetail]);

  useEffect(() => {
    if (userData) {
      fetchSubscriptionDetail();
    }
  }, [userData]);

  const handleImageChange = async (event, typee) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("image", event.target.files[0]);
      const response = await axios({
        method: "post",
        url: `${baseUrl}image/upload`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (typee) {
        setInputValues((prevValues) => ({
          ...prevValues,
          workerBgImages: [...inputValues.workerBgImages, response?.data?.url],
        }));
        setInputError((prevError) => ({
          ...prevError,
          workerBgImages: false,
        }));
      } else {
        setInputValues((prevValues) => ({
          ...prevValues,
          image: response?.data?.url,
        }));
        setInputError((prevError) => ({
          ...prevError,
          image: false,
        }));
      }
      handleOpenSnackBar("success", t("imageUploadSuccess"));
    } catch (error) {
      handleOpenSnackBar("error", t("imageUploadFailed"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeInputs = (event) => {
    const { name, value } = event.target;
    setInputError((err) => ({
      ...err,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
      isPasswordStrong:
        name === "password" ? false : inputError.isPasswordStrong,
      confirmPassword:
        name === "confirmPassword" ? false : inputError.confirmPassword,
      isPasswordMatch:
        name === "confirmPassword" ? false : inputError.isPasswordMatch,
    }));
    setInputValues((val) => ({ ...val, [name]: value }));
  };

  const handleAddEditWorker = async (params, type) => {
    const validate = registerWorkerValidation(
      inputValues,
      setInputError,
      workerDetail
    );
    if (validate) {
      return;
    }

    const isCreate = !workerDetail;

    const selectedServices = allServices
      .filter((service) => service.isSelected)
      .map((service) => ({
        services: service._id,
        subServices: service.subservices
          .filter((sub) => sub.isSelected)
          .map((sub) => sub.subServiceDetails._id),
      }));

    if (selectedServices.length === 0) {
      handleOpenSnackBar("error", t("selectAtLeastOneMainService"));
      return;
    }

    if (selectedServices.every((service) => service.subServices.length === 0)) {
      handleOpenSnackBar("error", t("selectAtLeastOneSubService"));
      return;
    }

    if (
      selectedServices.length > subscriptionDetail?.maxServicesLimit &&
      isCreate
    ) {
      handleOpenSnackBar(
        "error",
        t("maxOneMainService", {
          mainServiceCount: subscriptionDetail?.maxServicesLimit,
        })
      );
      return;
    }

    for (const service of selectedServices) {
      if (
        service.subServices.length > subscriptionDetail?.maxSubServicesLimit &&
        isCreate
      ) {
        handleOpenSnackBar(
          "error",
          `You can select a maximum of ${subscriptionDetail?.maxSubServicesLimit} sub-services per main service.`
        );
        return;
      }
    }

    if (isCreate) {
      try {
        setIsLoading(true);

        const response = await companyCanCreateWorker(userData?.adminId);
        const canCreate = response?.data?.data;

        if (!canCreate) {
          return openConfirmationDialog.current.isVisible({
            type: "staff_limit_reached",
          });
        }
      } catch (error) {
        return handleOpenSnackBar("error", error.message);
      } finally {
        setIsLoading(false);
      }
    }

    const longitude = location?.lng || location.coordinates[0];
    const latitude = location?.lat || location.coordinates[1];

    const locationObject = {
      addressLabel:
        inputValues.location.label || inputValues.location?.addressLabel,
      formatedAddress: location?.address || location?.formatedAddress,
      type: "Point",
      coordinates: [longitude, latitude],
    };

    let payload = {
      profileImg: inputValues.image,
      name: inputValues.name,
      contact: inputValues.contact,
      country: inputValues.country,
      city: inputValues.city,
      state: inputValues.state,
      location: locationObject,
      gender: inputValues.gender,
      expertise: inputValues.expertise,
      companyId: userData?.adminId,
      services: selectedServices,
      role: "Worker",
      backgroundImages: inputValues.workerBgImages,
      requestType: type,
      ...(isCreate && {
        email: inputValues.email,
        password: encryptPassword(inputValues.password),
      }),
      ...(isCreate &&
        type === "paid" &&
        params && {
          type: params.type,
          subscriptionId: params?.subscription?._id,
          tokenId: params?.tokenId,
        }),
    };

    if (isCreate) {
      handleApiCall(registerWorkerByCompany, payload, "");
    } else {
      handleApiCall(updateWorkderDetail, payload, workerDetail?._id);
    }
  };

  const handleApiCall = async (apiFunction, payload, id) => {
    try {
      setIsLoading(true);
      const response = await apiFunction(id, payload);
      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
        dispatch(
          setActiveTab({
            ...activeTab,
            company_worker_client: "workerList",
          })
        );
        dispatch(setWorkerDetail(null));
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", t("somethingWentWrong"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectMainService = (index) => {
    const updatedServices = [...allServices];
    const mainService = updatedServices[index];
    mainService.isSelected = !mainService.isSelected;

    if (!mainService.isSelected) {
      mainService.subservices = mainService.subservices.map((sub) => ({
        ...sub,
        isSelected: false,
      }));
    }
    setAllServices(updatedServices);
  };

  const handleSelectSubService = (mainIndex, subIndex) => {
    const updatedServices = [...allServices];
    updatedServices[mainIndex].subservices[subIndex].isSelected =
      !updatedServices[mainIndex].subservices[subIndex].isSelected;
    setAllServices(updatedServices);
  };

  const fetchPlaceDetails = async (object) => {
    try {
      setIsLoading(true);
      const response = await getAddressDetailByPlaceId(object.value.place_id);

      if (response?.data?.status === "success") {
        const data = response.data.data;
        const lat = data.result.geometry.location.lat;
        const lng = data.result.geometry.location.lng;
        console.log("Latitude:", lat, "Longitude:", lng);

        setLocation({
          address: data.result.formatted_address,
          lat,
          lng,
        });
      } else {
        handleOpenSnackBar("error", t("placeDetailsUnavailable"));
      }
    } catch (error) {
      handleOpenSnackBar("error", t("errorFetchingPlaceDetails"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenStripeDialog = async (subscription) => {
    const validate = registerWorkerValidation(
      inputValues,
      setInputError,
      workerDetail
    );
    if (validate) {
      return;
    }

    const selectedServices = allServices
      .filter((service) => service.isSelected)
      .map((service) => ({
        services: service._id,
        subServices: service.subservices
          .filter((sub) => sub.isSelected)
          .map((sub) => sub.subServiceDetails._id),
      }));

    if (selectedServices.length === 0) {
      handleOpenSnackBar("error", t("selectAtLeastOneMainService"));
      return;
    }

    if (selectedServices.every((service) => service.subServices.length === 0)) {
      handleOpenSnackBar("error", t("selectAtLeastOneSubService"));
      return;
    }

    if (selectedServices.length > subscriptionDetail?.maxServicesLimit) {
      handleOpenSnackBar(
        "error",
        t("maxOneMainService", {
          mainServiceCount: subscriptionDetail?.maxServicesLimit,
        })
      );
      return;
    }

    for (const service of selectedServices) {
      if (
        service.subServices.length > subscriptionDetail?.maxSubServicesLimit
      ) {
        handleOpenSnackBar(
          "error",
          t("maxTwoSubServices", {
            subServiceCount: subscriptionDetail?.maxSubServicesLimit,
          })
        );
        return;
      }
    }

    try {
      const mainResponse = await companyCanCreateWorker(userData?.adminId);

      if (mainResponse?.data?.status === "success") {
        const canCreate = mainResponse?.data?.data;

        if (canCreate) {
          handleAddEditWorker(null, "free");
        } else {
          handleOpenSnackBar(
            "error",
            "You have reached the maximum number of workers. Please upgrade to a paid plan to add more workers."
          );
        }
      } else {
        handleOpenSnackBar("error", mainResponse?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllStates = async () => {
    try {
      const response = await GetState(181);
      setAllStates(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const getAllCities = async () => {
    try {
      const stateName = inputValues.state?.toLowerCase();
      const findState = allStates.find(
        (val) => val.name?.toLowerCase() === stateName
      );

      const response = await GetCity(181, findState?.id);
      setAllCities(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getAllStates();
  }, []);

  useEffect(() => {
    if (inputValues.state && allStates.length > 0) {
      getAllCities();
    }
  }, [inputValues.state, allStates]);

  console.log(subscriptionDetail, "subscriptionDetail");

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={
          workerDetail === null ? t("addNewWorker") : t("editWorkerDetails")
        }
        secondaryHeading={t("accountInfoNote")}
        showBackButton={true}
        handleBack={() => {
          dispatch(
            setActiveTab({
              ...activeTab,
              company_worker_client: "workerList",
            })
          );
          dispatch(setWorkerDetail(null));
        }}
      >
        <Typography
          mt={2}
          mb={4}
          variant="h3"
          fontSize={"1.225rem"}
          fontWeight={500}
        >
          {t("workerDetails")}
        </Typography>
        <UploadImageAvatar
          error={inputError.image}
          image={inputValues.image}
          handleImageChange={handleImageChange}
        />

        <Grid container mt={3} spacing={2}>
          <Grid item xs={12}>
            <Label
              labelText={t("uploadBackgroundImages", { maxImagesCount: 4 })}
              htmlFor={"full-name"}
              required
            />
            {inputValues.workerBgImages.length < 4 && (
              <Box
                sx={{
                  border: "1px solid #00000024",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "flex-start",
                  padding: "10px",
                  cursor: "pointer",
                  width: "40px",
                  height: "40px",
                }}
                onClick={() => uploadRef.current.click()}
              >
                <CameraAltIcon style={{ fontSize: "40px" }} />
              </Box>
            )}
            <input
              style={{ height: 0, width: 0, visibility: "hidden" }}
              ref={uploadRef}
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "multiple")}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {inputValues.workerBgImages.map((urlllll, inddd) => {
                return (
                  <Box sx={{ position: "relative" }}>
                    <img
                      src={urlllll}
                      alt="bg"
                      style={{
                        width: "150px",
                        height: "150px",
                      }}
                    />
                    <Box
                      onClick={() => {
                        let arrrr = [...inputValues.workerBgImages];
                        arrrr.splice(inddd, 1);
                        setInputValues({
                          ...inputValues,
                          workerBgImages: arrrr,
                        });
                      }}
                      sx={{
                        position: "absolute",
                        height: "25px",
                        width: "25px",
                        background: "#fff",
                        border: "1px solid #00000024",
                        borderRadius: "50%",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <DeleteIcon
                        style={{
                          color: "red",
                          fontSize: "20px",
                        }}
                      />
                    </Box>
                  </Box>
                );
              })}
            </Box>
            {inputError.workerBgImages && (
              <FormHelperText sx={{ color: "custom.errorRed" }}>
                {t("minimumImagesRequired", {
                  minimumImagesCount: 2,
                })}
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Label labelText={t("fullName")} required htmlFor={"full-name"} />
            <TextInput
              styleProps={globalStyle.textField}
              id={"full-name"}
              required
              inputError={inputError.name}
              helperText={inputError.name && t("fullNameRequired")}
              placeholder={`${t("enter")} ${t("fullName")}`}
              type={"text"}
              name={"name"}
              value={inputValues.name}
              onChange={handleChangeInputs}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Label
              labelText={t("emailAddress")}
              required
              htmlFor={"email-address"}
            />
            <TextInput
              styleProps={globalStyle.textField}
              id={"email-address"}
              required
              inputError={inputError.email || inputError.isEmailValid}
              helperText={
                inputError.email
                  ? t("emailRequired")
                  : inputError.isEmailValid
                  ? t("invalidEmailFormat")
                  : null
              }
              placeholder={`${t("enter")} ${t("emailAddress")}`}
              type={"email"}
              name={"email"}
              value={inputValues.email}
              onChange={handleChangeInputs}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Label
              labelText={t("contactNumber")}
              htmlFor={"contact_number"}
              required
            />
            <RomanianPhoneInput
              inputError={inputError.contact}
              value={inputValues.contact}
              onChange={(value) => {
                setInputValues((prev) => ({ ...prev, contact: value }));
                setInputError((err) => ({ ...err, contact: false }));
              }}
            />
            {inputError.contact && (
              <FormHelperText sx={{ color: "#d32f2f" }}>
                {t("contactRequired")}
              </FormHelperText>
            )}
            {/* <TextInput
              styleProps={globalStyle.textField}
              id={"contact_number"}
              required={true}
              inputError={inputError.contact}
              helperText={inputError.contact && t("contactRequired")}
              placeholder={`${t("enter")} ${t("contactNumber")}`}
              type={"number"}
              name="contact"
              value={inputValues.contact}
              onChange={handleChangeInputs}
            /> */}
          </Grid>

          <Grid item xs={12} md={4}>
            <Label labelText={t("country")} required htmlFor={"country"} />
            <TextInput
              styleProps={globalStyle.textField}
              id={"country"}
              readonly
              value={"Romania"}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Label labelText={t("state")} htmlFor={"state"} required />
            <CustomDropDown
              selectError={inputError.state}
              helperText={inputError.state && t("stateRequired")}
              name={"state"}
              value={inputValues.state}
              onChange={handleChangeInputs}
            >
              <MenuItem value={""} disabled>
                Select State
              </MenuItem>
              {allStates?.map((val, _i) => (
                <MenuItem key={val.id} value={val.name.toLowerCase()}>
                  {val.name}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} md={4}>
            <Label labelText={t("city")} htmlFor={"city"} required />
            <CustomDropDown
              selectError={inputError.city}
              helperText={inputError.city && t("cityRequired")}
              name={"city"}
              value={inputValues.city}
              onChange={handleChangeInputs}
            >
              <MenuItem value={""} disabled>
                Select City
              </MenuItem>
              {allCities?.map((val, _i) => (
                <MenuItem key={val.id} value={val.name.toLowerCase()}>
                  {val.name}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>

          <Grid item xs={12}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Label
                labelText={t("searchLocation")}
                required
                htmlFor={"worker-address"}
              />
            </Stack>
            <GooglePlacesAutocomplete
              apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
              selectProps={{
                value: location?.addresss,
                onChange: (e) => {
                  setInputError((err) => ({ ...err, location: false }));
                  setInputValues((prev) => ({ ...prev, location: e }));
                  fetchPlaceDetails(e);
                },
              }}
            />

            {inputError.location && (
              <FormHelperText sx={{ color: "#d32f2f" }}>
                {t("selectYourLocation")}
              </FormHelperText>
            )}

            <Label
              labelText={t("selectedAddress")}
              htmlFor={"location"}
              labelProps={{ mt: 1 }}
              required
            />

            <TextInput
              styleProps={globalStyle.textField}
              id={"location"}
              placeholder={`${t("enter")} ${t("location")}`}
              inputError={inputError.location}
              helperText={inputError.location && t("locationRequired")}
              required
              readonly
              value={
                inputValues.location?.label ||
                inputValues.location?.addressLabel
              }
            />

            {/* <TextInput
              styleProps={globalStyle.textField}
              id={"worker-address"}
              required={true}
              inputError={inputError.location}
              helperText={inputError.location && "Location is required"}
              placeholder={"Enter location"}
              type={"text"}
              name="location"
              value={inputValues.location}
              onChange={handleChangeInputs}
            /> */}
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Label labelText={t("expertise")} required />
            <CustomDropDown
              selectError={inputError.expertise}
              helperText={inputError.expertise && t("expertiseRequired")}
              name={"expertise"}
              value={inputValues.expertise}
              onChange={handleChangeInputs}
            >
              <MenuItem value={""} disabled>
                {t("select")} {t("expertise")}
              </MenuItem>
              {EXPERTISE.map((val, index) => (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
          {/* 
          <Grid item xs={12} sm={6} md={4}>
            <Label labelText="Birthday" required />
            <DatePicker
              sx={{
                "&.MuiTextField-root": { width: "100% !important" },
                ...globalStyle.textField,
              }}
              err
              name="dob"
              value={inputValues.dob}
              onChange={handleDateChange}
            />
          </Grid> */}

          <Grid item xs={12} sm={6} md={4}>
            <Label labelText={t("gender")} required />
            <CustomDropDown
              selectError={inputError.gender}
              helperText={inputError.gender && t("genderRequired")}
              name={"gender"}
              value={inputValues.gender}
              onChange={handleChangeInputs}
            >
              <MenuItem disabled>{t("selectGender")}</MenuItem>
              {GENDER.map((val, index) => (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
          {workerDetail == null && (
            <>
              <Grid item xs={12} sm={6} md={4}>
                <Label
                  labelText={t("password")}
                  required
                  htmlFor={"worker-password"}
                />
                <TextInput
                  id={"worker-password"}
                  styleProps={globalStyle.textField}
                  inputError={
                    inputError.password || inputError.isPasswordStrong
                  }
                  helperText={
                    inputError.password
                      ? t("passwordRequired")
                      : inputError.isPasswordStrong
                      ? t("passwordRequirements")
                      : null
                  }
                  required
                  placeholder={`${t("enter")} ${t("password")}`}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={inputValues.password}
                  onChange={handleChangeInputs}
                  InputEndIcon={
                    showPassword ? (
                      <RemoveRedEyeIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(false)}
                      />
                    ) : (
                      <VisibilityOffIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(true)}
                      />
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Label
                  labelText={`${t("reEnter")} ${t("password")}`}
                  required
                  htmlFor={"worker-confirm-password"}
                />
                <TextInput
                  id={"worker-confirm-password"}
                  styleProps={globalStyle.textField}
                  required
                  inputError={
                    inputError.confirmPassword || inputError.isPasswordMatch
                  }
                  helperText={
                    inputError.confirmPassword
                      ? t("confirmPasswordRequired")
                      : inputError.isPasswordMatch
                      ? t("passwordMismatch")
                      : null
                  }
                  placeholder={`${t("reEnter")} ${t("password")}`}
                  type={"password"}
                  name={"confirmPassword"}
                  value={inputValues.confirmPassword}
                  onChange={handleChangeInputs}
                />
              </Grid>
            </>
          )}
        </Grid>

        <Typography
          variant="h5"
          my={2}
          fontWeight={600}
          textTransform={"capitalize"}
        >
          {t("selectServices")}
        </Typography>

        <Stack spacing={2}>
          {allServices?.map((item, index) => (
            <Stack
              key={index}
              direction="column"
              spacing={1}
              bgcolor="#f1f1f1"
              p={1}
              border="1px solid #e9e8e8"
            >
              <Stack direction="row" spacing={1}>
                <Checkbox
                  checked={item.isSelected}
                  onChange={() => handleSelectMainService(index)}
                />
                <Stack direction="row" spacing={1}>
                  <Avatar
                    src={item.image}
                    sx={{
                      height: 70,
                      width: 70,
                      borderRadius: "6px",
                    }}
                  />
                  <Box>
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      textTransform="capitalize"
                    >
                      {item.name[currentLanguage]}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {item.description[currentLanguage]}
                    </Typography>
                  </Box>
                </Stack>
              </Stack>

              {/* Subservices */}
              {item.isSelected &&
                item.subservices.map((sub, subIndex) => (
                  <Stack
                    key={subIndex}
                    direction="row"
                    spacing={1}
                    pl={4}
                    alignItems="center"
                    bgcolor={"#ffffff"}
                    py={1}
                  >
                    <Checkbox
                      checked={sub.isSelected}
                      onChange={() => handleSelectSubService(index, subIndex)}
                    />
                    <Avatar
                      src={sub.subServiceDetails.image}
                      sx={{
                        height: 50,
                        width: 50,
                        borderRadius: "6px",
                      }}
                    />
                    <Box>
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        textTransform={"capitalize"}
                      >
                        {sub.subServiceDetails.name[currentLanguage]}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {sub.subServiceDetails.description[currentLanguage]}
                      </Typography>
                      <Stack
                        direction={{ md: "row" }}
                        gap={1}
                        alignItems={"center"}
                      >
                        <Typography
                          variant="body2"
                          textTransform={"capitalize"}
                        >
                          {t("serviceCharges")} :
                          {sub.subServiceDetails.percentage}%
                        </Typography>
                        <Typography
                          variant="body2"
                          textTransform={"capitalize"}
                        >
                          {t("companyPercentage")} :{sub.percentage}%
                        </Typography>
                        <Typography variant="body2">
                          {t("yourPercentage")} :
                          {100 -
                            sub.percentage -
                            sub.subServiceDetails.percentage}
                          %
                        </Typography>
                        {sub.subServiceDetails?.type === "fixed" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("serviceCharges")}: {sub?.price?.fixed || 0}
                          </Typography>
                        )}
                        {sub.subServiceDetails?.type === "area" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("perAreaCharges")}: {sub?.price?.area || 0}
                          </Typography>
                        )}

                        {sub.subServiceDetails?.type === "room+area" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("perAreaCharges")}: {sub?.price?.area || 0}{" "}
                            <br />
                            {t("perRoomCharges")}: {sub?.price?.room || 0}
                          </Typography>
                        )}
                        {sub.subServiceDetails?.type ===
                          "interior+exterior" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("interiorCharges")}: {sub?.price?.interior || 0}{" "}
                            <br />
                            {t("exteriorCharges")}: {sub?.price?.exterior || 0}
                          </Typography>
                        )}
                        {/* Duration */}
                        {sub.subServiceDetails?.type === "fixed" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("serviceDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.fixed || 0}
                          </Typography>
                        )}
                        {sub.subServiceDetails?.type === "area" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("perAreaDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.area || 0}
                          </Typography>
                        )}

                        {sub.subServiceDetails?.type === "room+area" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("perAreaDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.area || 0} <br />
                            {t("perRoomDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.room || 0}
                          </Typography>
                        )}
                        {sub.subServiceDetails?.type ===
                          "interior+exterior" && (
                          <Typography
                            variant="body2"
                            color="text.mediumGray"
                            fontWeight={600}
                          >
                            {t("interiorDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.interior || 0}{" "}
                            <br />
                            {t("exteriorDuration")}:{" "}
                            {sub?.subServiceDetails.duration?.exterior || 0}
                          </Typography>
                        )}
                      </Stack>
                    </Box>
                  </Stack>
                ))}
            </Stack>
          ))}
        </Stack>

        <Stack>
          <GlobalButton
            variant={"custom_contained"}
            btnText={workerDetail ? t("editWorker") : t("addWorker")}
            handleClickBtn={() => {
              if (workerDetail) {
                handleAddEditWorker(null, null);
              } else {
                handleAddEditWorker(null, "free");

                // handleOpenStripeDialog();
                // handleAddEditWorker(null, null);
              }
            }}
            styleProps={{ my: 3 }}
          />
        </Stack>
      </AppContainer>
      <ConfirmationDialog ref={openConfirmationDialog} showCloseBtn={true} />
      {/* <Elements stripe={stripePromise}>
        <SubscriptionPurchaseDialog
          ref={openSubscriptionDialog}
          onPayment={(params) => handleAddEditWorker(params, "paid")}
        />
      </Elements> */}
    </>
  );
};

export default AddEditWorker;
